"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { nav, profile } from "@/content/site";

function isActive(pathname: string, href: string) {
  if (href === "/") {
    return pathname === "/";
  }
  return pathname === href || pathname.startsWith(`${href}/`);
}

export function SiteHeader({ overlay = false }: { overlay?: boolean }) {
  const pathname = usePathname();

  return (
    <header
      className={`${overlay ? "absolute inset-x-0 top-0" : "sticky top-0"} z-20 bg-black/80 text-white backdrop-blur-xl`}
    >
      <div className="mx-auto flex h-12 w-full max-w-[1200px] items-center justify-between px-5">
        <Link href="/" className="flex items-baseline gap-2 text-[15px] font-semibold tracking-tight">
          <span>{profile.name}</span>
          <span className="font-normal text-white/80">{profile.nameZh}</span>
        </Link>
        <nav className="flex items-center gap-3 text-[12px] text-[#d2d2d7] md:gap-5">
          {nav.map((item) => {
            const active = isActive(pathname, item.href);
            return (
              <Link
                key={item.href}
                href={item.href}
                className={active ? "text-white" : "hover:text-white"}
                aria-current={active ? "page" : undefined}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}

export function SiteHeaderFallback() {
  return <header className="h-12 bg-black" />;
}
